(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('slideshow:select', (event) => {
    const component = event.target instanceof Element ? event.target.closest('slideshow-component') : null;
    if (!component) return;

    const progress = component.querySelector('.slideshow-progress');
    if (!progress) return;

    const segments = progress.querySelectorAll('.slideshow-progress__segment');
    if (segments.length < 2) return;

    const index = typeof event.detail?.index === 'number' ? event.detail.index : 0;

    segments.forEach((segment, i) => {
      const isActive = i === index;
      segment.setAttribute('aria-selected', isActive ? 'true' : 'false');
      segment.classList.toggle('is-active', isActive);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grids = document.querySelectorAll('[data-tab-grid]');

    grids.forEach(function (grid) {
      var buttons = Array.prototype.slice.call(grid.querySelectorAll('[data-tab-button]'));
      var panels = grid.querySelectorAll('[data-tab-panel]');

      function activate(button) {
        var tabId = button.getAttribute('data-tab-button');

        buttons.forEach(function (b) {
          var isActive = b === button;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          b.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          var show = panel.getAttribute('data-tab-panel') === tabId;
          panel.classList.toggle('is-hidden', !show);
          panel.classList.toggle('is-active', show);
        });

        button.focus();
      }

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          activate(button);
        });

        button.addEventListener('keydown', function (event) {
          var last = buttons.length - 1;
          var target = null;

          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              target = buttons[index === last ? 0 : index + 1];
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              target = buttons[index === 0 ? last : index - 1];
              break;
            case 'Home':
              target = buttons[0];
              break;
            case 'End':
              target = buttons[last];
              break;
          }

          if (target) {
            event.preventDefault();
            activate(target);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
